import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Check from './svg/check.svg';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

export default class SelectedIndicator extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    isVisible: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    iconClassName: null,
    isVisible: false,
  };

  getRootClasses() {
    const { className, iconClassName, isVisible } = this.props;

    return cx({
      [className]: className !== null,
      [iconClassName]: iconClassName !== null,
      isVisible,
      Root: true,
    });
  }

  render() {
    const { iconClassName } = this.props;
    if (iconClassName !== null) return <div className={ this.getRootClasses() } />;

    return (
      <div
        className={ this.getRootClasses() }
      >
        <Check />
      </div>
    );
  }
}
